import Layout from '../../../../common/components/layout/Layout';
// import StepsPlay from '../../../../common/components/modules/home/StepsPlay';
import Header from '../../../../common/components/layout/Header';
import RentFields from '../../../../common/components/modules/sports/RentFields';
import { attributesBySport } from '../../../../common/data/attributes';

const Horarios = (): JSX.Element => {
    const attribute = attributesBySport('rent');
    return (
        <Layout navProps={{ title: 'Reservar | Supermatch', description: 'Reservar Supermatch' }}>
            <>
                <Header />
                <RentFields attribute={attribute} />
                {/* <StepsPlay /> */}
            </>
        </Layout>
    );
};

export default Horarios;
